export const errorDetails = (errorCode: string) => {
  switch (errorCode) {
    case 'email_not_registered':
      return {
        header: 'Email not registered',
        message: 'No user with such account is present in the system.',
      };
    default:
      return {
        header: 'Login failed',
        message: 'Unexpected login error occurred. Please contact the system administrator.',
      };
  }
};

export const ErrorMessage = ({ header, message }: { header: string; message: string }) => (
  <div
    style={{
      display: 'flex',
      alignItems: 'flex-start',
      gap: '12px',
      padding: '12px 16px',
      backgroundColor: 'var(--color-danger-bg-accent-subtle-default, #fff6f6)',
      border: '1px solid var(--color-danger-border-accent, #e0b4b4)',
      borderRadius: '4px',
      color: 'var(--color-danger-text-accent, #9f3a38)',
    }}>
    <span style={{ fontSize: '18px' }}>⚠</span>
    <div>
      <div style={{ fontWeight: 600, marginBottom: '4px' }}>{header}</div>
      <p style={{ margin: 0 }}>{message}</p>
    </div>
  </div>
);
